<template>
  <v-app id="app" :class="{ 'app-impersonating': isImpersonating }">
    <bar />
    <navigation />
    <ImpersonationBanner />
    <v-main class="main-app">
      <router-view />
    </v-main>
  </v-app>
</template>
<script>
import {mapState} from 'vuex'

import {carnotDrawer} from '@/utils/drawer'

import bar from './components/bar.vue'
import ImpersonationBanner from './components/ImpersonationBanner.vue'
import navigation from './components/navigation.vue'
import {contexts} from './store/context'

export default {
  components: {navigation, bar, ImpersonationBanner},
  computed: {
    ...mapState({currentContext: state => state.context.currentContext}),
    isImpersonating() {
      return this.$store.getters.isImpersonating
    }
  },
  watch: {
    currentContext() {
      this.$store.dispatch('getClient')
      this.navigate()
    }
  },
  mounted() {
    this.$store.dispatch('getDatabase')
  },
  methods: {
    navigate() {
      this.$store.dispatch('getDatabase')
      if (this.$route.path === '/achats' || this.$route.path === '/tableauAchats') {
        const achatsPath = this.currentContext === contexts.BOUCHERIE_CONTEXT
          ? '/tableauAchats'
          : '/achats'

        if (this.$route.path !== achatsPath) {
          this.$router.push({path: achatsPath})
        }
        return
      }
      if (
        this.currentContext === contexts.BOUCHERIE_CONTEXT &&
        !carnotDrawer.links.find(link => link.to === this.$route.path)
      ) {
        this.$router.push({name: 'tracabilite'})
      } else if (
        this.currentContext === contexts.POISSONNERIE_CONTEXT &&
        !hublotDrawer.links.find(link => link.to === this.$route.path)
      ) {
        this.$router.push({name: 'home'})
      }
    }
  }
}
</script>

<style lang="scss">
.app-impersonating .v-app-bar {
  top: 40px !important;
}

.app-impersonating .v-navigation-drawer {
  top: 40px !important;
  height: calc(100% - 40px) !important;
}

.app-impersonating .main-app {
  margin-top: 40px;
}

.v-chip:hover {
  cursor: pointer;
}

.main-app {
  flex: 1; // pour qu'elle prenne tout l'espace dispo après bar et navigation
  padding-left: 60px !important;
  overflow-y: auto;
}

#app,
.v-application,
.v-main {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

/* Chrome */
input::-webkit-inner-spin-button,
input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Opéra*/
input::-o-inner-spin-button,
input::-o-outer-spin-button {
  -o-appearance: none;
  margin: 0
}

.v-application--wrap {
  --background : #f4f1f1;
}
#app {
  background-color: #f4f1f1;
  height: 100vh;
  overflow: hidden; // facultatif si tu gères tout via .main-app
  display: flex;
  flex-direction: column;
}
</style>
